import styled from 'styled-components'
import { Noto_body1_r16, Noto_subheading_b18 } from 'src/styles/fonts/NotoSansKrFonts'
import { Container } from 'src/components/common/Container'
import Button, { ButtonOption2, ButtonOption3 } from 'src/components/common/Button'
import {
  kakaomapInfoAuthUpdate,
  useCustomMutation,
} from 'src/hooks/react-query/useCustomMutation.hook'
import { KakaoMapInfoAuthUpdateSpace } from 'src/types/api'
import { useModal } from 'src/provider/ModalContextProvider'
import { Bridge } from 'src/utils/bridge'

const KakaoLocationInfoCorrectTerms = ({
  okCallbackFn,
  cancelCallbackFn,
}: {
  okCallbackFn?: () => void
  cancelCallbackFn?: () => void
}) => {
  const { closeModal } = useModal()
  const { mutate: updateKakaoMapInfoAuth } = useCustomMutation<
    KakaoMapInfoAuthUpdateSpace.Request,
    KakaoMapInfoAuthUpdateSpace.Response
  >(kakaomapInfoAuthUpdate())

  const handleAgreeStart = () => {
    closeModal?.()
    updateKakaoMapInfoAuth({ IsAgree: 'Y' })
    okCallbackFn?.()
  }

  const handleCancel = () => {
    closeModal?.()
    cancelCallbackFn?.()
  }

  const handleTermsContents = () =>
    Bridge.handleReqExternalOpenUrl('https://www.kakao.com/policy/location')

  return (
    <Container $option="flex_column">
      <S.ModalTitle>카카오 위치정보 이용약관 동의</S.ModalTitle>
      <S.ModalContents>고객님의 위치를 기반으로 매장 정보가 표시됩니다.</S.ModalContents>
      <Container $option="flex_column" $row_gap="12px">
        <Button option={ButtonOption3('active')} onClickFn={handleAgreeStart}>
          동의 후 위치공유 시작
        </Button>
        <Button option={ButtonOption3('default')} onClickFn={handleTermsContents}>
          약관보기
        </Button>
        <Button option={ButtonOption2('strong')} onClickFn={handleCancel}>
          닫기
        </Button>
      </Container>
    </Container>
  )
}
export default KakaoLocationInfoCorrectTerms

const S = {
  ModalTitle: styled.p`
    display: block;
    text-align: center;
    ${Noto_subheading_b18};
    margin-bottom: 10px;
  `,
  ModalContents: styled.span`
    display: block;
    width: 100%;
    height: 100%;
    max-height: 212px;
    overflow: auto;
    ${Noto_body1_r16};
    white-space: pre-wrap;
    margin: 0 auto 26px auto;
  `,
}
